import { type LiveTerminal, TERMINAL_ENDPOINTS } from '@iws/backoffice-api'

import { httpRequest } from '@/clients/http'

/** Terminals are created online only (POS.md §12.11): the server numbers them (Q27). */
export const TerminalModel = {
  create: (body: { name: string; branch_id: string }) =>
    httpRequest<{ result: { _id: string; unique_no: number } }>({ method: 'post', url: '/api/backoffice/terminal', body }),
  /** Online: each terminal of the branch with its open shift (POS.md §18, Terminals page). */
  live: (branchId: string) => httpRequest<{ result: LiveTerminal[] }>({ method: 'get', url: TERMINAL_ENDPOINTS.live, query: { branch_id: branchId } }),
  requestClose: (shiftId: string) =>
    httpRequest<{ result: unknown }>({ method: 'post', url: TERMINAL_ENDPOINTS.requestClose.replace(':id', shiftId) }),
}
